<template>
  <PaginationComponent
    ref="pagination"
    :totalItems="totalItems"
    :totalPages="totalPages"
    :page="paginationSetting.page"
    :pageSize="paginationSetting.pageSize"
    @on-page-change="getData"
  />
</template>

<script>
import PaginationComponent from '@/components/base/PaginationComponent.vue';
import PaginationSetting from '@/ecm/models/PaginationSetting';

export default {
    components: {
        PaginationComponent
    },
    props: {
        totalItems: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            paginationSetting: new PaginationSetting()
        };
    },
    computed: {
        totalPages() {
            return Math.max(1, Math.ceil(this.totalItems / this.paginationSetting.pageSize));
        }
    },
    methods: {
        getData({ page, pageSize }) {
            this.paginationSetting.page = page;
            this.paginationSetting.pageSize = pageSize;

            const maxPage = Math.ceil(this.totalItems / pageSize);

            if (this.paginationSetting.page > maxPage) {
                this.paginationSetting.page = maxPage;
            }

            this.$emit('on-page-change', {
                page: this.paginationSetting.page,
                pageSize: this.paginationSetting.pageSize
            });
        },
        resetPagination() {
            this.$refs.pagination.reset(true);
        }
    }
};
</script>